var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app-top"},[_c('top-title',{attrs:{"dataList":_vm.topTitleList,"height":300}})],1),_c('div',{staticClass:"container"},[_c('div',{staticClass:"my-p-t-40 my-p-b-20"},[_c('versions-buy')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }